/* @flow */
import File from 'entities/File';
import { getGlyphName } from 'lib/FileTypes';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

import filesize from 'filesize';
import './styles/FilePreview.scss';

export type FilePreviewerProps = {
  file: File,
};

// TODO rename to FileGenericPreview now that we have lots of File previewing components
class FilePreview extends React.Component {
  static propTypes = {
    file: React.PropTypes.instanceOf(File).isRequired,
  };

  state = {
    isHovering: false,
  };

  endHover = () => {
    this.setState({ isHovering: false });
  };

  startHover = () => {
    this.setState({ isHovering: true });
  };

  render() {
    const { file } = this.props;

    const size = file.getSize();
    let displayedSize = '';
    if (size) {
      displayedSize = filesize(size, { round: 1, spacer: '' }).toUpperCase();
    }

    const contentType = file.getContentType();
    const preview = (
      <Link
        className="FilePreview"
        href={file.getUrls().cdn}
        target="_blank"
        eventElementName="FilePreview">
        <div
          className="FilePreview-preview"
          onMouseEnter={this.startHover}
          onMouseLeave={this.endHover}>
          <Glyph
            className="FilePreview-icon"
            name={this.state.isHovering ? 'download' : getGlyphName(contentType)}
            size="xxxlarge"
          />
          <div className="FilePreview-name">{file.getName()}</div>
          <div className="FilePreview-size"><em>{displayedSize}</em></div>
        </div>
      </Link>
    );

    return preview;
  }
}

export default FilePreview;



// WEBPACK FOOTER //
// ./src/groups/components/FilePreview.jsx